import { PayoutType } from 'types';
import { Payout } from 'store/api/payout';
import { isUnderMinimumItem } from 'utils/under-minimum';

export const negativeSplitTypes = [
  PayoutType.NegativeTip,
  PayoutType.NegativeEarnings,
  PayoutType.NegativeAdjustment,
];

const isRefundItem = (item: Payout) =>
  item.notes?.includes('Refund earning for sale');

/**
 * Refund and Chargeback groups for the deductions block. Under Minimum lines
 * (owner, 22 Oct 2026) are their own group, whatever their item type, and
 * never count as Refund or Chargeback.
 */
export const splitNegativeItems = (items: Payout[]) => {
  const negativeItems = items.filter(
    (item) =>
      negativeSplitTypes.includes(item.type as PayoutType) &&
      !isUnderMinimumItem(item)
  );

  return {
    refundItems: negativeItems.filter(isRefundItem),
    underMinimumItems: items.filter(isUnderMinimumItem),
    chargebackItems: negativeItems.filter((item) => !isRefundItem(item)),
  };
};

export const sumItems = (items: Payout[]) =>
  items.reduce((acc, item) => acc + Number(item.amount || 0), 0);
